<template>
  <!-- no banners border bottom -->
  <section
    v-if="item.propertyInfo && item.propertyInfo.BillingDuplicateNumber"
    class="container bg-white sticky-top d-print-none"
    :class="isFutureOrPast ? '' : 'border-bottom'"
    id="parcel-toolbar"
  >
    <div class="row py-1 pe-3">
      <div
        class="col-12 text-center col-md-3"
        id="desktop-back-to-search"
        :class="{
          'd-none': mini,
          'text-md-start': isFuture,
          'text-md-center': !isFuture,
        }"
      >
        <a
          v-on:click="goBackToSearch()"
          class="btn btn-link px-1 text-decoration-none"
          title="Back to Search"
        >
          <b
            >&#60;
            <SearchSVG :fillColor="'rgb(52, 148, 148)'" />
            Back To Search</b
          >
        </a>
      </div>
      <div id="toolbar-select-container">
        <div
          v-if="item.taxHistory && item.taxHistory.length && !isFuture"
          class="d-flex align-items-center"
        >
          <strong class="ms-2">Pay Year:</strong>
          <select
            name="payYear"
            @change="selectPayYear($event)"
            class="ms-2 border shadow-sm rounded bg-white"
          >
            <option
              v-for="record in item.taxHistory"
              v-bind:key="record.PayYear"
              :selected="record.PayYear == $route.params.payYear"
              :value="record.PayYear"
              ><span>{{ record.PayYear }}</span></option
            >
          </select>
        </div>
        <div class="d-flex align-items-center">
          <strong class="ms-2">Jump To:</strong>
          <select
            name="jumpTo"
            id="jump-to"
            @change="jumpTo($event.target.value)"
            class="ms-2 border shadow-sm rounded bg-white"
            style="width: auto;"
          >
            <option
              v-for="section in sections"
              v-bind:key="section"
              :selected="section === currentSection"
              :value="section"
              class="bg-white"
              ><span>{{
                section === "tax-overview" && !widerThan360
                  ? "Overview"
                  : formatSection[section]
              }}</span>
            </option>
          </select>
        </div>
      </div>
      <div id="additional-options-container">
        <div
          class="centered"
          id="mobile-back-to-search"
          :class="{
            'text-md-start': isFuture,
            'text-md-center': !isFuture,
          }"
        >
          <a
            v-on:click="goBackToSearch()"
            class="btn btn-link px-1 text-decoration-none"
            title="Back to Search"
          >
            <b>&#60; &nbsp; {{ widerThan360 ? "Back To Search" : "Search" }}</b>
          </a>
        </div>
        <div class="centered">
          <additional-options-button
            :copyUrlToClipboard="copyUrlToClipboard"
            :item="item"
            :isFuture="isFuture"
            :county="county"
            :widerThan360="widerThan360"
            :isMobile="isMobile"
          />
        </div>
      </div>
      <div
        v-if="showCopyToClipboardAlert"
        class="col-10 offset-1 col-sm-6 offset-sm-3 col-md-4 offset-md-4 text-center position-absolute"
      >
        <div class="alert alert-info shadow" role="alert">
          URL copied to clipboard!
        </div>
      </div>
    </div>
    <future-or-past-banner
      v-if="isFutureOrPast || (isFuture && item.systemParameters[0].PayYear)"
      :currentPayYear="item.systemParameters[0].PayYear.toString()"
      :item="item.propertyInfo"
    />
    <button
      type="button"
      @click="jumpTo('home')"
      class="btn btn-primary btn-floating text-white shadow-lg border"
      id="btn-back-to-top"
    >
      <BackToTopSVG :fillColor="'white'" />
      Back To Top
    </button>
  </section>
</template>
<style scoped>
.mobile #toolbar-select-container {
  display: flex;
  flex-direction: column-reverse;
  width: 55%;
  justify-content: space-around;
  padding: 0;
}
.mobile #additional-options-container {
  display: flex;
  width: 45%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0;
}
.desktop #toolbar-select-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 50%;
}
.desktop #additional-options-container {
  display: flex;
  flex-direction: row;
  width: 25%;
}
.mobile #desktop-back-to-search,
.desktop #mobile-back-to-search {
  display: none;
}
.desktop #desktop-back-to-search,
.mobile #mobile-back-to-search {
  display: block;
}
.arrow-remove {
  overflow: hidden;
}
.arrow-remove select {
  width: 100px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.select-arrow-down {
  border: solid black;
  border-width: 0 0.15rem 0.15rem 0;
  display: inline-block;
  height: 0.5rem;
  width: 0.5rem;
  padding: 0.25rem;

  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
#btn-back-to-top:hover {
  background-color: rgb(0, 85, 86, 0.8);
}
#btn-back-to-top {
  position: fixed;
  bottom: 45px;
  right: 45px;
  display: none;
}
/* option {
  font-family: "Lato", Arial, Helvetica, sans-serif;
} */
</style>
<script>
import AdditionalOptionsButton from "./AdditionalOptionsButton.vue";
import FutureOrPastBanner from "./FutureOrPastBanner.vue";
import SearchSVG from "../svg/SearchSVG.vue";
import BackToTopSVG from "../svg/BackToTopSVG.vue";
export default {
  components: {
    BackToTopSVG,
    SearchSVG,
    FutureOrPastBanner,
    AdditionalOptionsButton,
  },
  data() {
    return {
      widerThan360: window.screen.width > 360,
      currentSection: "home",
      sections: !this.isFuture
        ? ["home", "billing", "tax-overview", "history"]
        : ["home", "history"],
      formatSection: {
        home: "Info",
        billing: "Billing",
        "tax-overview": "Tax Overview",
        history: "History",
      },
      baseUrl: process.env.BASE_URL,
      mini: false,
      showCopyToClipboardAlert: false,
    };
  },
  computed: {
    isFutureOrPast() {
      return this.item.systemParameters[0].PayYear &&
        this.item.propertyInfo.PAYYEAR !== this.item.systemParameters[0].PayYear
        ? true
        : false;
    },
  },
  methods: {
    copyUrlToClipboard: function() {
      var el = document.createElement("input");
      document.body.appendChild(el);
      el.value = window.location.href;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.showCopyToClipboardAlert = true;
      setTimeout(() => {
        this.showCopyToClipboardAlert = false;
      }, 2500);
    },
    goBackToSearch() {
      let cachedQuery =
        JSON.parse(sessionStorage.getItem("search-query")) || null;
      const cachedSearchResults =
        JSON.parse(sessionStorage.getItem("search-results")) || null;
      if (
        !this.isFuture &&
        cachedQuery &&
        cachedSearchResults &&
        (cachedSearchResults.Results.length > 1 ||
          Object.keys(cachedQuery).length > 1 ||
          !("parcelNumber" in cachedQuery))
      ) {
        this.$router.replace({
          name: "county",
          params: {
            county: this.county.name,
          },
          query: cachedQuery,
        });
      } else {
        // return to search with blank search form
        this.$router.replace({
          name: "county",
          params: {
            county: this.county.name,
          },
        });
      }
    },
    selectPayYear(event) {
      // .replace (unlike .push) prevents navigation from being added to history
      this.$router.replace({
        name: "parcel",
        params: {
          dup: this.item.propertyInfo.BillingDuplicateNumber,
          payYear: event.target.value,
        },
      });
    },
    jumpTo(event) {
      if (event === "home") {
        window.scrollTo(window.scrollX, 0);
        const backToTop = document.getElementById("btn-back-to-top");
        this.currentSection = "home";
        if (backToTop) {
          backToTop.style.display = "none";
        }
      } else {
        const toolbar = document.getElementById("parcel-toolbar");
        const el = document.getElementById(event).getBoundingClientRect();
        const location = el.top - toolbar.offsetHeight;
        window.scrollTo(window.scrollX, window.pageYOffset + location);
        const backToTop = document.getElementById("btn-back-to-top");
        if (backToTop) {
          backToTop.style.display = "block";
        }
      }
    },
  },

  mounted() {
    // show mini toolbar when scrolling down (medium screen and smaller only)
    window.addEventListener("scroll", () => {
      if (window.screen.width < 768) {
        const currentScroll = window.pageYOffset;
        this.mini = this.mini ? currentScroll > 48 : currentScroll > 144;
      }
      let section = document.querySelectorAll("section");
      let inView;
      for (let i = 0; i < section.length; i += 1) {
        const sec = section[i];

        let top = window.scrollY;
        let offset = sec.offsetTop - 200;
        let height = sec.offsetHeight;
        let id = sec.getAttribute("id");
        if (id === "history") {
          offset -= 500;
        }
        if (top >= offset && top < offset + height) {
          if (id !== "parcel-toolbar") {
            inView = id === null || id === "info" ? "home" : id;
          }
        }
      }

      if (inView && this.currentSection !== inView) {
        this.currentSection = inView;
      }

      const backToTopButton = document.getElementById("btn-back-to-top");
      if (backToTopButton) {
        if (
          (document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20) &&
          (screen.width > 750 ||
            (screen.width <= 750 &&
              window.innerHeight + window.pageYOffset <
                document.body.scrollHeight))
        ) {
          backToTopButton.style.display = "block";
        } else {
          backToTopButton.style.display = "none";
        }
      }
    });
    screen.orientation.addEventListener(
      "change",
      function() {
        this.widerThan360 = screen.width > 360;
      },
      false
    );
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    anyAlerstsExist: {
      type: String,
      required: false,
    },
    isMobile: {
      type: String, //'mobile' | 'desktop'
      required: true,
    },
  },
};
</script>
